import React from 'react';


//className="table table-bordered table-hover"
const keyTable = (props)  => {

    // Data
    const dataColumns = props.columns;
    const dataRows = props.rows;
    //const dataColumns = this.props.data.columns;
    //const dataRows = this.props.data.rows;

    const tableHeaders = (<thead>
          <tr>
          <span> &nbsp;&nbsp;</span>
            {dataColumns.map(function(column) {
                return       <th>{column}</th>        ;})}
          </tr>
      </thead>);

    const tableBody = dataRows.map(function(row) {
      return (
        <tr>
        <span> &nbsp;&nbsp;</span>
          {dataColumns.map(function(column) {
            return <td>{row[column]}</td>; })}
        </tr>); });

    // Decorate with Bootstrap CSS
    return (<table  >
        {tableHeaders}
        {tableBody}
      </table>) };

export default keyTable;



// WEBPACK FOOTER //
// ./src/components/table.js